import {Grid} from '@mui/material'

type LayoutProps = {
  janusKpisSlot?: React.ReactNode
  rcfaSlot?: React.ReactNode
  scoreProgressSlot?: React.ReactNode
  expertSystemSlot?: React.ReactNode
  runningTimesSlot?: React.ReactNode
  qualityKpisSlot?: React.ReactNode
}

export const PlantStatusTrendLayout = ({
  janusKpisSlot,
  runningTimesSlot,
  expertSystemSlot,
  scoreProgressSlot,
  rcfaSlot,
  qualityKpisSlot
}: LayoutProps) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <Grid container direction={'column'} spacing={2}>
          <Grid item>{janusKpisSlot}</Grid>
          <Grid item>{scoreProgressSlot}</Grid>
          <Grid item>{expertSystemSlot}</Grid>
          <Grid item>{qualityKpisSlot}</Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} md={6}>
        <Grid container direction={'column'} spacing={2}>
          <Grid item>{rcfaSlot}</Grid>
          <Grid item>{runningTimesSlot}</Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

